import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsApp from "../FloatingWhatsApp";
import ScrollProgress from "../ui/ScrollProgress";
import GrainOverlay from "../graphics/GrainOverlay";

export default function Layout() {
  return (
    <>
      <ScrollProgress />
      <GrainOverlay />
      <Navbar />
      <main><Outlet /></main>
      <FloatingWhatsApp />
      <Footer />
    </>
  );
}
